import { graphHooks } from '@tunasong/graph-lib/react'
import type { Note } from '@tunasong/models'
import type { Entity, Persisted } from '@tunasong/schemas'
import { Button } from '@tunasong/ui-lib'
import type { FC } from 'react'
import { usePerformanceConfig } from './part/performance-config.hook.js'

interface NotesToggleProps {
  entity: Persisted<Entity>
}

/**
 * Perform header "My notes (n)": turns the performer's private notes on or off. The choice is remembered
 * per user (profile config) and the notes never open on their own.
 *
 * Shares the RTK Query cache key with `EntityNotes`, so showing the notes does not refetch.
 */
export const NotesToggle: FC<NotesToggleProps> = ({ entity }) => {
  const { entities: notes } = graphHooks.useEntityChildren<Note>({ parentId: entity.id, filter: 'note' })
  const { config, updatePerformanceConfig } = usePerformanceConfig()
  const visible = config.notesVisible ?? false
  const count = notes.length

  return (
    <Button
      variant={visible ? 'contained' : 'text'}
      color="inherit"
      size="small"
      aria-pressed={visible}
      onClick={() => updatePerformanceConfig({ notesVisible: !visible })}
    >
      {count > 0 ? `My notes (${count})` : 'My notes'}
    </Button>
  )
}

export default NotesToggle
